<template>
  <div :class="classlist" v-if="this.flag && content">
    <p>{{content}}</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      flag: false,
      classlist: ['toastmain'],
    };
  },
  props: {
    duration: {
      type: Number,
      default: 1500, // 持续显示的时长，单位 ms 为 0 则不自动消失需手动点击
    },
    content: {
      type: String,
      default: null,
    },
  },
  methods: {
    show() {
      const that = this;
      this.flag = true;
      setTimeout(() => {
        that.hide();
      }, that.duration);
    },
    hide() {
      this.classlist.push('fade');
      setTimeout(() => {
        this.flag = false;
      }, 500);
    },
  },
  created() {
    this.$nextTick(() => {
      this.show();
    });
  },
};
</script>
<style scoped>
.toastmain {
  opacity: 0.8;
  background: #000;
  max-width: 85%;
  position: fixed;
  top: 300px;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 6px;
  padding: 10px 14px;
  box-sizing: border-box;
  z-index: 9999999;
}
.toastmain p {
  color: #fff;
  text-align: center;
  font-size: 14px;
  line-height: 1.2;
}
.fade {
  opacity: 0;
  transition: all ease-in-out 0.4s;
}
</style>
